import React from "react";
import { HomeOutlined, PlusOutlined, DeleteOutlined } from "@ant-design/icons"; 
import { Breadcrumb, Button, Form, Input, Modal, Table, Space, Popconfirm } from "antd"; 
import "./item_location.css";
import withItemLocationLogic, { InjectedProps, RackLocationDataType } from "../../components/hoc_item_location"; 
import ModalListDataItemLocation from "./modal_list_data_item_location";
import ModalListItemLocation from "./modal_list_item_location";

const ItemLocation: React.FC<InjectedProps> = ({ 
    showModal,
    isModalOpen,
    handleOk,
    handleCancel,
    isModalTwoOpen,
    showModalTwo,
    handleOkTwo,
    handleCancelTwo,
    form, 
    dataSource, 
    isLoading, 
    pagination, 
    rowSelection, 
    columns, 
    isAdding, 
    editingKey, 
    selectedRowKeys, 
    handleAdd, 
    handleDelete, 
    handleSubmit, 
    handleTableChange, 
    handleRowSelect, 
    handleRowSelectTwo, 
}) => {
    const transformStyle = { 
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (
        <div id="ilqt" style={transformStyle}>
            <div className="gjs-grid-row" id="ir41">
                <div className="gjs-grid-column" id="i79m">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/history_data_item_location",
                                title: (
                                    <>
                                        <span>History Transaction Item Location</span>
                                    </>
                                ),
                            },
                            {
                                title: "Item Location",
                            },
                        ]}
                    />
                </div>
            </div>
            <div className="gjs-grid-row" id="uu87392">
                <div className="gjs-grid-column" id="dbf783">
                    <Button className="gr-button" onClick={handleSubmit} >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path
                                fillRule="evenodd"
                                d="M9 1.5H5.625c-1.036 0-1.875.84-1.875 1.875v17.25c0 1.035.84 1.875 1.875 1.875h12.75c1.035 0 1.875-.84 1.875-1.875V12.75A3.75 3.75 0 0 0 16.5 9h-1.875a1.875 1.875 0 0 1-1.875-1.875V5.25A3.75 3.75 0 0 0 9 1.5Zm6.61 10.936a.75.75 0 1 0-1.22-.872l-3.236 4.53L9.53 14.47a.75.75 0 0 0-1.06 1.06l2.25 2.25a.75.75 0 0 0 1.14-.094l3.75-5.25Z"
                                clipRule="evenodd"
                            />
                            <path d="M12.971 1.816A5.23 5.23 0 0 1 14.25 5.25v1.875c0 .207.168.375.375.375H16.5a5.23 5.23 0 0 1 3.434 1.279 9.768 9.768 0 0 0-6.963-6.963Z" />
                        </svg>
                        Submit
                    </Button>
                </div>
            </div>

            <div className="gjs-grid-row" id="ik9qu">
                <div className="gjs-grid-column" id="ir1f6">
                    <Form
                        form={form}
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '180px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item
                            label="Warehouse"
                            name="warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input placeholder="" readOnly />
                        </Form.Item>
                        <div className="grid2">
                            <label style={{ fontWeight: 600 }}> From Rack Location </label>
                            <Form.Item
                                label="Item Code"

                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <Form.Item name="item_code_from" noStyle style={{ width: "85%" }}>
                                        <Input
                                            placeholder=""
                                            style={{ width: "90%" }}
                                        />
                                    </Form.Item>
                                    <Button
                                        type="primary"
                                        id="modal_list_data_item_location"
                                        onClick={showModal}
                                        icon={
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                style={{
                                                    width: "22px",
                                                    height: "22px",
                                                }}
                                            >
                                                <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                <path
                                                    fillRule="evenodd"
                                                    d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                    clipRule="evenodd"
                                                />
                                                <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                            </svg>
                                        }
                                    />
                                </div>
                            </Form.Item>
                            <Form.Item
                                label="Item Name"
                                name="item_name_from"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Rack Location Code"
                                name="rack_location_code_from"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Rack Location Name"
                                name="rack_location_name_from"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                        </div>
                        <div className="grid2">
                            <label style={{ fontWeight: 600, paddingBottom: 40 }}> To Rack Location</label>
                            <Form.Item
                                label="Item Code"
                                name="item_code_to"
                                style={{
                                    marginBottom: "5px",
                                    width: "78%"
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Item Name"
                                name="item_name_to"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                            <Form.Item
                                label="Rack Location Code"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                    <Form.Item name="rack_location_code" noStyle style={{ width: "85%" }}>
                                        <Input
                                            placeholder=""
                                            style={{ width: "90%" }}
                                        />
                                    </Form.Item>

                                    <Button
                                        type="primary"
                                        id="modal_list_item_location"
                                        onClick={showModalTwo}
                                        icon={
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                viewBox="0 0 24 24"
                                                fill="currentColor"
                                                style={{
                                                    width: "22px",
                                                    height: "22px",
                                                }}
                                            >
                                                <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                                <path
                                                    fillRule="evenodd"
                                                    d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z"
                                                    clipRule="evenodd"
                                                />
                                                <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                            </svg>
                                        }
                                    />
                                </div>
                            </Form.Item>
                            <Form.Item
                                label="Rack Location Name"
                                name="rack_location_name_to"
                                style={{
                                    marginBottom: "5px",
                                }}
                            >
                                <Input placeholder="" />
                            </Form.Item>
                        </div>
                    </Form>
                </div>
            </div>
            <div className="gjs-grid-row" id="i6hu2">
                <div className="gjs-grid-column" id="i1dci">
                </div>
            </div>
            <Modal
                title="List Data Item Location"
                open={isModalOpen}
                onOk={handleOk}
                onCancel={handleCancel}
                width={1000}
                footer={null}
            >
                <ModalListDataItemLocation onRowSelect={handleRowSelect} />
            </Modal>
            <Modal
                title="List Item Location"
                open={isModalTwoOpen}
                onOk={handleOkTwo}
                onCancel={handleCancelTwo}
                width={1000}
                footer={null}
            >
                <ModalListItemLocation onRowSelect={handleRowSelectTwo} />
            </Modal>
            <div className="gjs-grid-row" id="xxdsa3">
                <div className="gjs-grid-column" id="fdcc42">
                    <Space style={{ marginBottom: 16 }}>
                        <Button
                            onClick={handleAdd}
                            type="primary"
                            icon={<PlusOutlined />}
                            disabled={isAdding || editingKey !== '' || selectedRowKeys.length > 0}
                        >
                            Add Rack
                        </Button>
                        <Popconfirm
                            title={`Hapus ${selectedRowKeys.length} item terpilih?`}
                            description="Tindakan ini tidak dapat dibatalkan. Pastikan lokasi rak tidak sedang digunakan."
                            onConfirm={handleDelete}
                            okText="Ya, Hapus"
                            cancelText="Tidak"
                            disabled={selectedRowKeys.length === 0}
                        >
                            <Button
                                type="primary"
                                danger
                                icon={<DeleteOutlined />}
                                disabled={selectedRowKeys.length === 0}
                            >
                                Delete Rack
                            </Button>
                        </Popconfirm>
                    </Space>
                    <Form form={form} component={false}>
                        <Table
                            rowKey="id"
                            rowSelection={rowSelection}
                            columns={columns}
                            dataSource={dataSource}
                            loading={isLoading}
                            rowClassName="editable-row"
                            pagination={pagination}
                            onChange={handleTableChange}
                        />
                    </Form>
                </div>
            </div>
        </div>
    );
};

export default withItemLocationLogic(ItemLocation);
